const IFRAME_PAGE_STYLE = {
  height: "580px",
  width: "100%",
};

export {
  IFRAME_PAGE_STYLE,
};


// WEBPACK FOOTER //
// ./src/components/MsoPaymentModal/styles.js